var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3647 10.9822C12.5622 10 11.9956 9.5 11.9956 6.79219C11.9956 4.3125 10.7294 3.42906 9.68717 3C9.54873 2.94312 9.41842 2.8125 9.37623 2.67031C9.19342 2.04812 8.68092 1.5 7.99967 1.5C7.31842 1.5 6.8056 2.04844 6.62467 2.67094C6.58248 2.81469 6.45217 2.94312 6.31373 3C5.27029 3.42969 4.00529 4.31 4.00529 6.79219C4.00373 9.5 3.43717 10 2.63467 10.9822C2.30217 11.3891 2.59342 12 3.17498 12H12.8275C13.4059 12 13.6953 11.3872 13.3647 10.9822Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12V12.5C10 13.0304 9.78929 13.5391 9.41421 13.9142C9.03914 14.2893 8.53043 14.5 8 14.5C7.46957 14.5 6.96086 14.2893 6.58579 13.9142C6.21071 13.5391 6 13.0304 6 12.5V12",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.1c3c64dc7b669c06a4f6f5ff93e23257.svg";
export { ForwardRef as ReactComponent };